"use strict";

import {onFind} from "./elements-packages/init-modules-in-scope";
import {on, removeAttribute} from '@elements/dom-utils';
import {registerPermissionGrantedCallback} from "@elements/cookie-permissions";

export function init () {
    onFind(".js-open-chat-link", function (chatLink) {
        let cookieService = chatLink.dataset.loadChatWithConsent || false;

        if (cookieService) {
            registerPermissionGrantedCallback(cookieService, function () {
                removeAttribute('hidden', chatLink);
                let aiScript = document.createElement('script');
                aiScript.type = 'text/javascript';
                aiScript.src = 'https://concierge.goodguys.ai/client/6554cac3892c9d5bfdb43388/ai_concierge.js';
                document.head.appendChild(aiScript);
            });
        } else {
            console.warn('load-chat-with-consent: no cookie service name found!')
        }
    });
}